import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isModalOpen: false,
    modalContent: null,
    modalContentProps: null,
    isOnline: navigator.onLine,
    isSyncing: false,
};
const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        setIsModalOpen: (state, action) => {
            state.isModalOpen = action.payload;
        },
        setModalContent: (state, action) => {
            state.modalContent = action.payload;
        },
        setModalContentProps: (state, action) => {
            state.modalContentProps = action.payload;
        },
        setIsOnline: (state, action) => {
            state.isOnline = action.payload;
        },
        setIsSyncing: (state, action) => {
            state.isSyncing = action.payload;
        },
    },
    selectors: {
        selectIsModalOpen: (state) => state.isModalOpen,
        selectModalContent: (state) => state.modalContent,
        selectModalContentProps: (state) => state.modalContentProps,
        selectIsOnline: (state) => state.isOnline,
        selectIsSyncing: (state) => state.isSyncing,
    },
});
export const { setIsModalOpen, setModalContent, setModalContentProps, setIsOnline, setIsSyncing } = globalSlice.actions;
export const { selectIsModalOpen, selectModalContent, selectModalContentProps, selectIsOnline, selectIsSyncing, } = globalSlice.selectors;
export default globalSlice.reducer;
